const ANALYTICS_EVENT_NAMES = {
  elementClicked: 'Element Clicked',
  initializeAmplitudeGuidesAndSurveys:
    'Initialize Amplitude Guides And Surveys',
  userEnteredInput: 'User Entered Input',
};

export default ANALYTICS_EVENT_NAMES;
